import type { Guide } from '../types';

/** S-21.10-03 — obieg prezlecenia CS → Administracja ze zwrotem z pytaniem (scenariusz e2e 16, MIX-01). */
export const guide: Guide = {
  flagKey: 'intakeHandoff',
  title: 'Obieg prezlecenia CS → Administracja ze zwrotem z pytaniem',
  whatItDoes:
    'Prezlecenie ma etap obiegu: u CS, u Administracji, zwrócone do CS z pytaniem, zatwierdzone. CS przekazuje je do Administracji, gdy jest zaakceptowane i nie brakuje pól wymaganych przez importer VIA. Administracja przed wytworzeniem pliku może je zwrócić z pytaniem — CS odpowiada w wątku i przekazuje ponownie. Dane zmienia tylko dział, u którego jest rekord; nic nie wychodzi pocztą.',
  audience: ['CS', 'Administracja'],
  presentationItems: ['S-21.10-03'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/show',
      record: {
        description: 'prezlecenie u CS — z kolejki „Do uzupełnienia”',
        listPath: '/pre-orders',
        listFilter: { intakeQueue: 'cs_todo' },
      },
      target: 'intake-flow-card',
      title: 'Etap obiegu na karcie prezlecenia',
      description:
        'Sekcja „Obieg CS → Administracja” mówi, u którego działu jest prezlecenie, od kiedy i ile razy wracało z pytaniem.',
      action: 'Otwórz prezlecenie i znajdź sekcję „Obieg CS → Administracja”.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'b1PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: {
        description: 'prezlecenie u CS — z kolejki „Do uzupełnienia”',
        listPath: '/pre-orders',
        listFilter: { intakeQueue: 'cs_todo' },
      },
      target: 'intake-blockers',
      title: 'Braki blokują przekazanie',
      description:
        'Dopóki brakuje pól, bez których importer VIA nie przyjmie pliku, przekazanie jest nieaktywne, a lista mówi, czego brakuje.',
      action: 'Uzupełnij wymienione pola w „Dane dla importera”.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'b1PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: {
        description: 'prezlecenie u CS — z kolejki „Do uzupełnienia”',
        listPath: '/pre-orders',
        listFilter: { intakeQueue: 'cs_todo' },
      },
      target: 'intake-handoff',
      mockupTestId: 'cs-zlecenie-przekaz',
      title: 'Przekazanie do Administracji',
      description:
        'Po uzupełnieniu braków CS przekazuje prezlecenie z krótką uwagą. Od tej chwili dane zmienia Administracja, a CS widzi podgląd.',
      action: 'Kliknij „Przekaż do Administracji” i wpisz uwagę.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'b1PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: {
        description: 'prezlecenie u Administracji — z kolejki „Do kontroli”',
        listPath: '/pre-orders',
        listFilter: { intakeQueue: 'adm_control' },
      },
      target: 'intake-return',
      mockupTestId: 'adm-zlecenie-zwrot-cs',
      title: 'Zwrot do CS z pytaniem',
      description:
        'Zanim powstanie plik, Administracja może zwrócić prezlecenie do CS z pytaniem (co najmniej 10 znaków). Zatwierdzenie zapisu się wtedy cofa, a pytanie trafia do wątku prezlecenia.',
      action: 'W oknie kontroli kliknij „Zwróć do CS z pytaniem” i wpisz pytanie.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'vatPreOrders.pick' } },
    },
    {
      route: '/intake-dashboard',
      target: 'intake-tile-cs_returned',
      title: 'Zwrot wraca na pulpit CS',
      description:
        'Zwrócone prezlecenie czeka na pulpicie CS w kolejce „Zwrócone z pytaniem”. CS odpowiada w wątku na karcie i przekazuje ponownie — przy prezleceniu rośnie licznik zwrotów.',
      action: 'Kliknij kafelek „Zwrócone z pytaniem”, otwórz prezlecenie i odpowiedz.',
      recorder: { account: 'cs' },
    },
  ],
};
